<script setup lang="ts">
import {ArrowRight, Baby, Bone, HeartPulse, ShieldCheck, Sparkles, Stethoscope} from 'lucide-vue-next';

const services = [{
  icon: ShieldCheck,
  title: 'Prophylaxe',
  text: 'Vorsorge, professionelle Zahnreinigung und individuelle Beratung für dauerhaft gesunde Zähne.'
}, {
  icon: HeartPulse,
  title: 'Zahnerhaltung & Endodontie',
  text: 'Substanzschonende Verfahren zum langfristigen Erhalt Ihrer natürlichen Zähne.'
}, {
  icon: Baby,
  title: 'Kinderzahnheilkunde',
  text: 'Behutsame, spielerische Vorsorge für Vertrauen und einen entspannten Praxisbesuch.'
}, {
  icon: Bone,
  title: 'Zahnersatz & Implantologie',
  text: 'Passgenaue Kronen, Brücken und implantatgetragene Versorgungen für sicheren Kaukomfort.'
}, {
  icon: Sparkles,
  title: 'Ästhetische Zahnheilkunde',
  text: 'Zahnfarbene Restaurationen und sorgfältig abgestimmte Konzepte für natürliche Ästhetik.'
}, {
  icon: Stethoscope,
  title: 'Parodontologie & CMD',
  text: 'Systematische Behandlung des Zahnhalteapparates und funktioneller Beschwerden.'
}]</script>
<template>
  <div>
    <section class="page-hero">
      <div class="container"><span class="eyebrow">Unser Behandlungsspektrum</span>
        <h1>Moderne Zahnmedizin.<br><em>Individuell für Sie.</em></h1>
        <p>Von der Vorsorge bis zur komplexen Versorgung begleiten wir Sie kompetent und persönlich.</p></div>
    </section>
    <section class="section">
      <div class="container">
        <div class="service-grid">
          <article v-for="(s,i) in services" :key="s.title" class="service-card">
            <div class="service-top"><span class="service-icon"><component :is="s.icon"/></span><span
                class="service-number">0{{ i + 1 }}</span></div>
            <h3>{{ s.title }}</h3>
            <p>{{ s.text }}</p>
            <router-link to="/kontakt">Termin anfragen
              <ArrowRight/>
            </router-link>
          </article>
        </div>
      </div>
    </section>
    <section class="subpage-cta">
      <div class="container"><h2>Welche Behandlung passt zu Ihnen?</h2>
        <p>Wir beraten Sie verständlich und ohne Zeitdruck.</p>
        <router-link to="/kontakt" class="button primary">Kontakt aufnehmen
          <ArrowRight/>
        </router-link>
      </div>
    </section>
  </div>
</template>
